export const reactionTokens = {
    slot: 48,
    artwork: 40,
    preview: 64,
    selected: 32,
    summary: 24,
    circle: '50%',
    pill: 999,
    openDelay: 200,
    closeDelay: 250,
    holdDelay: 350,
    pickerGap: 8,
    viewportMargin: 16,
} as const;